// extracted by mini-css-extract-plugin
export var bodyRow = "_fr-d";
export var cardColumns = "_fr-e";
export var ellipsesOverflow = "_fr-2";
export var flatBottomCorners = "_fr-3";
export var flatTopCorners = "_fr-4";
export var headerActionsDropdown = "_fr-f";
export var headerBottomRow = "_fr-c";
export var headerTopRow = "_fr-b";
export var orderDetailsWrapper = "_fr-0";
export var orderInfoContainer = "_fr-1";
export var productDetails = "_fr-9";
export var productImage = "_fr-5";
export var responsiveTable = "_fr-8";
export var shipmentContainer = "_fr-a";
export var tableBottomLeft = "_fr-6";
export var tableBottomRight = "_fr-7";
export var trackingLink = "_fr-g";